var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.survey && _vm.survey.feedback)?_c('div',[_c('Message',{attrs:{"content":_vm.content,"user":_vm.user || {},"timestamp":_vm.created,"highlights":_vm.highlights,"type":"incoming","label":"Feedback"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }